"use client";
import {
  __name
} from "../../../chunk-SHUYVCID.js";

// src/sections/core/contact/contact-card.tsx
import { Icon } from "@core/icons";
import { Button } from "@core/ui/components/atoms/button";
import { Card, CardContent, CardHeader, CardTitle } from "@core/ui/components/atoms/card";
import { Container } from "@core/ui/components/atoms/container";
import { Input } from "@core/ui/components/atoms/input";
import { Label } from "@core/ui/components/atoms/label";
import { Textarea } from "@core/ui/components/atoms/textarea";
import { match } from "ts-pattern";
import { jsx, jsxs } from "react/jsx-runtime";
function ContactFormFieldCard({ field }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
    /* @__PURE__ */ jsx(Label, { htmlFor: field.id, children: field.label }),
    match(field.type).with("text", "email", "tel", (type) => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type,
        placeholder: field.placeholder,
        required: field.required
      }
    )).with("textarea", () => /* @__PURE__ */ jsx(
      Textarea,
      {
        id: field.id,
        name: field.id,
        placeholder: field.placeholder,
        required: field.required,
        rows: 4
      }
    )).with("select", () => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type: "text",
        placeholder: field.placeholder,
        required: field.required
      }
    )).exhaustive()
  ] });
}
__name(ContactFormFieldCard, "ContactFormFieldCard");
function formatAddressCard(address) {
  const parts = [
    address.line1,
    ...address.line2 != null ? [address.line2] : [],
    [address.city, address.region, address.postalCode].filter(Boolean).join(", "),
    address.country
  ];
  return parts;
}
__name(formatAddressCard, "formatAddressCard");
function ContactCard({ content, themeId }) {
  if (content == null) {
    return null;
  }
  const { heading, description, email, phone, address, formConfig } = content;
  return /* @__PURE__ */ jsx("section", { className: "bg-muted/30 px-6 py-16 md:\
py-24", "data-theme": themeId, children: /* @__PURE__ */ jsx(Container, { size: "\
lg", children: /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-2xl space\
-y-8", children: [
    /* @__PURE__ */ jsxs(Card, { children: [
      /* @__PURE__ */ jsxs(CardHeader, { children: [
        /* @__PURE__ */ jsx(CardTitle, { className: "text-2xl", children: heading }),
        description != null && /* @__PURE__ */ jsx("p", { className: "text-muted\
-foreground", children: description })
      ] }),
      /* @__PURE__ */ jsxs(CardContent, { className: "flex flex-col gap-4", children: [
        email != null && /* @__PURE__ */ jsxs("div", { className: "flex items-ce\
nter gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "Mail", className: "size-5 text-prim\
ary" }),
          /* @__PURE__ */ jsx(
            "a",
            {
              href: `mailto:${email}`,
              className: "text-muted-foreground hover:text-foreground",
              children: email
            }
          )
        ] }),
        phone != null && /* @__PURE__ */ jsxs("div", { className: "flex items-ce\
nter gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "Phone", className: "size-5 text-pri\
mary" }),
          /* @__PURE__ */ jsx("a", { href: `tel:${phone}`, className: "text-mute\
d-foreground hover:text-foreground", children: phone })
        ] }),
        address != null && /* @__PURE__ */ jsxs("div", { className: "flex items-\
start gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "MapPin", className: "mt-0.5 size-5 \
text-primary" }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-col text-muted-fore\
ground", children: formatAddressCard(address).map((line) => /* @__PURE__ */ jsx(
          "span", { children: line }, line)) })
        ] })
      ] })
    ] }),
    formConfig != null && /* @__PURE__ */ jsxs(Card, { children: [
      /* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsx(CardTitle,
      { className: "text-xl", children: "Send us a message" }) }),
      /* @__PURE__ */ jsx(CardContent, { children: /* @__PURE__ */ jsxs(
        "form",
        {
          action: formConfig.formAction,
          method: "POST",
          className: "flex flex-col gap-4",
          "data-success-message": formConfig.successMessage,
          children: [
            formConfig.fields.map((field) => /* @__PURE__ */ jsx(ContactFormFieldCard,
            { field }, field.id)),
            /* @__PURE__ */ jsx(Button, { type: "submit", className: "mt-2 w-ful\
l", children: formConfig.submitText ?? "Send Message" })
          ]
        }
      ) })
    ] })
  ] }) }) });
}
__name(ContactCard, "ContactCard");
export {
  ContactCard
};
